module.exports = __webpack_public_path__ + "img/linkedin.5ae2a38c.png";